import { useState, useEffect } from "react";
import { CellWrapper } from "./cellWrapper";
import { FormHelperText, IconButton, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  wrapperclass: {
    textAlign: "center",
    "& div": {
      "& fieldset": {
        verticalAlign: "middle",
        "& label": {
          marginLeft: 0,
          marginRight: 0,
        },
      },
    },
  },
}));
export const CustomIconRowCell = (props) => {
  const {
    value: initialValue,
    row: { index, original },
    column: {
      id,
      isReadOnly,
      activeIcon: { icon: TrueIcon, tooltip: trueTooltip },
      inActiveIcon: { icon: FalseIcon, tooltip: falseTooltip },
    },
    loading,
    onButtonActionHandel,
  } = props;

  const externalTouched = Boolean(original?._touched?.[id]);
  const externalError = original?._error?.[id] ?? "";
  const classes = useStyles();
  const [value, setValue] = useState(initialValue);

  const onClick = () => {
    if (typeof onButtonActionHandel === "function") {
      onButtonActionHandel(index, id);
    }
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue, externalError]);

  return (
    <CellWrapper {...props}>
      <div className={classes.wrapperclass}>
        {Boolean(value) ? (
          <Tooltip title={trueTooltip}>
            <IconButton
              name={id}
              onClick={onClick}
              disabled={loading || isReadOnly}
            >
              {TrueIcon ?? ""}
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title={falseTooltip}>
            <IconButton onClick={onClick} disabled={loading || isReadOnly}>
              {FalseIcon ?? ""}
            </IconButton>
          </Tooltip>
        )}
        {Boolean(externalTouched) && Boolean(externalError) ? (
          <FormHelperText style={{ whiteSpace: "break-spaces" }} error={true}>
            {externalError}
          </FormHelperText>
        ) : null}
      </div>
    </CellWrapper>
  );
};
